import {action} from 'mobx';
import QuickTip from 'shared/components/QuickTip';
import { Layout } from 'shared/components/layouts';
import {t, withState, api} from 'shared/core';
import {auth, endpoints} from 'main/tools';
import {FormattedMessage} from 'react-intl';
import {redirect} from 'shared/tools';

const StopImpersonation = ({uiState}) => {
  return (
    <Layout>
      <div className='pt2'>
        <QuickTip
          trait='caution'
          header={auth.user.name}
          paragraphs={[
            // eslint-disable-next-line react/jsx-key
            <FormattedMessage id='components.stop_impersonation.VIEWING_AS' values={{
              user: auth.user.name
            }}/>
          ]}
          actions={[
            {
              caption: t('components.stop_impersonation.Return to Users'),
              onClick: () => uiState.stopImpersonation(),
              loadingText: t('components.stop_impersonation.Returning to Users...')
            }
          ]}
        />
      </div>
    </Layout>
  );
};

class StopImpersonationState {
  @action async stopImpersonation() {
    await api.put(endpoints.USERS.STOP_IMPERSONATING);
    return redirect('/company_settings/users');
  }
}

export default withState(StopImpersonation, StopImpersonationState);
